import { FunctionComponent, ReactNode } from 'react';

import {
  DispatchReduxFetch,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';

type PropsType = {
  required: DispatchReduxFetch[];
  renderLoading?: (percentage: string) => ReactNode;
  children?: ReactNode;
};

export const RequireReduxData: FunctionComponent<PropsType> = (
  props: PropsType,
) => {
  const { required, renderLoading, children } = props;

  const {
    requiredStatus: { isInitializing, percentage },
  } = useInitializeCommonReduxData({ required });

  if (isInitializing) {
    return <>{!!renderLoading && renderLoading(percentage)}</>;
  }

  return <>{children}</>;
};
